import React, { useEffect } from "react";
import { Loader } from "cxa-components";


const SinglifeRedirect = () => {
  const WEB_URL = 'https://mysinglife.singlife.com/account/login';
  const MOBILE_URL = 'https://app.singlife.com/bmOXrgQ0aHb';

  useEffect(() => {
    try {
      const userAgent = navigator.userAgent || window.opera;
      
      if (/android|iPad|iPhone|iPod/i.test(userAgent)) {
        window.location.href = MOBILE_URL;
      } else {
        window.location.href = WEB_URL;
      }
    } catch (error) {
      window.location.href = WEB_URL; // Fallback to web URL
    }
  }, []);


  // Loading state while redirect happens
  return <Loader />;
};

export default SinglifeRedirect;


// WEBPACK FOOTER //
// ./components/common/SinglifeRedirect.jsx